import { interfaceError } from '../../i18n/errorMessages';
import toast from '../../i18n/toast';
import React, {useEffect} from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { history } from "../../redux/store/configureStore";
import BooksList from "./BooksList";
import * as bookActions from "../../redux/actions/bookActions";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";

function Books({ books, loadBooks, ...props }) {
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);

  useEffect(() => {
    if (books.length === 0) {
      loadBooks()
        .catch((error) => {
          toast.error(interfaceError(error, 'common:errors.load'));
        });
    }
  }, []);


  const handleEdit = (book) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/book/${book.id}`, location.search, activeSchoolYearStartYear));
  };

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/book/new", location.search, activeSchoolYearStartYear));
  };

  return (
    <div className="mb-5">
      <BooksList
        books={books}
        onAdd={handleAdd}
        onEdit={handleEdit}
      />
    </div>
  );
}

Books.propTypes = {
  books: PropTypes.array.isRequired,
  loadBooks: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return ({
    books: state.books,
  });
};

const mapDispatchToProps = dispatch => ({
  loadBooks: () => dispatch(bookActions.loadBooks()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Books);
